import React from "react";
import Select from "antd/lib/select";
import Radio from "antd/lib/radio";
import Input from "antd/lib/input";
import { scratchFilter } from "../../lib/xes/data";
import RadioGroup from "antd/lib/radio/group";
import bindAll from 'lodash.bindall';
import "./tag-form.css";

const { TextArea } = Input
class TagForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = { ...this.props.defaultTag }
    
    this.handlers = {}
    this.init()
    bindAll(this, [
      'updateState',
      'init'
    ])
  }
  componentDidMount() {
  }
  componentDidUpdate(preProps) {
    if (this.props === preProps) {
      return
    }
    this.setState({...this.props.defaultTag})
  }
  init() {
    for (let key in this.state) {
      this.handlers[key] = (value) => {
        if (value.target) {
          value = value.target.value
        }
        this.updateState({
          [key]: value
        })
      }
    }
  }
  updateState(value) {
    this.setState(value, () => {
      this.props.updateTags({ ...this.state })
    })
  }
  render() {
    const Option = Select.Option
    return (
      <div>
        <div className='row'>
          <span>名称</span><Input defaultValue = {this.state.name} onBlur={this.handlers['name']} />
        </div>
        {
          [
            [
              {
                label: '学年',
                filter: scratchFilter.get('semester'),
                handler: this.handlers['semester'],
                defaultValue: this.state['semester']
              },
              {
                label: '学期',
                filter: scratchFilter.get('term'),
                handler: this.handlers['term'],
                defaultValue: this.state['term']
              }
            ],
            [
              {
                label: '等级',
                filter: scratchFilter.get('level'),
                handler: this.handlers['level'],
                defaultValue: this.state['level']
              },
              {
                label: '课次',
                filter: scratchFilter.get('lesson'),
                handler: this.handlers['lesson'],
                defaultValue: this.state['lesson']
              }
            ]
          ].map((items, index) => {
            return <div className='row'>
              {
                items.map((item, index) => {
                  return (
                    <div>
                      <span className='required'>* </span><span>{item.label}:</span>
                      <Select onChange={item.handler} defaultValue={item.defaultValue} style={{width: 120}}>
                        {
                          item.filter.map((filter, index) => {
                            return (
                              <Option value={filter.value}>{filter.text}</Option>
                            )
                          })
                        }
                      </Select>
                    </div>
                  )
                })
              }
            </div>
          })
        }
        {
          [
            {
              label: '用途',
              radioLabel: ['课中弹题', '随堂测'],
              handler: this.handlers['purpose'],
              value: 'purpose',
              defaultValue: this.state['purpose']

            },
            {
              label: '类型',
              radioLabel: ['题目', '答案'],
              handler: this.handlers['pro_type'],
              value: 'pro_type'
            }
          ].map(items => (
            <div className='row'>
              <span className='required'>* </span><span>{items.label}</span>
              {
                <RadioGroup onChange={items.handler} value={this.state[items.value]}>
                  {
                    items.radioLabel.map((label, index) => (
                      <Radio value={index+1}>{label}</Radio>
                    ))
                  }
                </RadioGroup>
              }
            </div>
          ))
        }
        <div className='row'>
            <span>题次：</span>
              <Select onChange={this.handlers['topic']} defaultValue={this.state['topic']} style={{width: 120}}>
                {
                  scratchFilter.get('topic').map((filter, index) => {
                    return (
                      <Option value={filter.value}>{filter.text}</Option>
                    )
                  })
                }
              </Select>
        </div>
        <div>
          <p>自定义标签：（标签之间用","隔开</p>
          <TextArea rows={5} defaultValue={this.state['tag']} onChange={this.handlers['tag']}></TextArea>
        </div>
      </div>
    )
  }
}

export default TagForm;
